module.exports = __webpack_public_path__ + "img/tp-1.78e610eb.png";